import React from 'react';
import {
  OfferStatusBadge,
  offerStatusColors
} from 'src/components/StatusBadge';
import {
  Badge,
  Card,
  Col,
  Icon,
  Link,
  ListGroup,
  ListGroupItem,
  Row,
  useApp
} from 'straightline-ui';
import { formatMoney } from 'straightline-utils/accounting';
import { STATUS } from 'straightline-utils/constants';
import { formatDistanceToNow } from 'straightline-utils/time';

export default function ShipmentOffersCard() {
  const app = useApp();
  const {
    result: offers,
    isLoading,
    isError
  } = app.service('api/shipment-offers').useFind(
    {
      $include: ['shipment'],
      query: {
        $limit: 5,
        $sort: { created_at: -1 },
        '$shipment.status_type$': STATUS.BOOKED
      }
    },
    { keepPreviousData: true, refetchInterval: 60000 }
  );

  if (isLoading || isError || !offers?.total) {
    return <Loader />;
  }

  return (
    <Card className="card-fill">
      <div className="card-header">
        <div className="d-flex justify-content-between">
          <h3 className="card-header-title">Load Offers</h3>
          <Link to="/shipment-offers">View All</Link>
        </div>
      </div>
      <ListGroup
        className={`list-group-flush ${
          offers.data.length < 5 ? 'border-bottom rounded-0' : ''
        }`}
      >
        {offers.data.map((offer) => {
          const isValid = !!offer.shipment;

          return (
            <ListGroupItem
              key={offer.id}
              tag={Link}
              to={`/shipment-matches/${offer.shipment_id}?shipment_offer_id=${offer.id}`}
              className="list-group-item-action"
              style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}
              disabled={!isValid}
            >
              <Row>
                <Col xs="auto">
                  <Badge
                    color={offerStatusColors[offer.status]}
                    className={`font-size-lg rounded-circle badge badge-${
                      offerStatusColors[offer.status]
                    } d-flex align-items-center justify-content-center`}
                    style={{ width: 40, height: 40 }}
                  >
                    <Icon type="dollar-sign" />
                  </Badge>
                </Col>
                <Col className="ml-n2">
                  <div className="mb-1 font-weight-bold">
                    {isValid ? (
                      <div className="mb-1 font-weight-bold">
                        {offer.shipment.pickup_address.city},{' '}
                        {offer.shipment.pickup_address.state} ⇢{' '}
                        {offer.shipment.delivery_address.city},{' '}
                        {offer.shipment.delivery_address.state}{' '}
                      </div>
                    ) : (
                      <div className="mb-1 font-weight-bold text-secondary">
                        Shipment no longer available.
                      </div>
                    )}
                  </div>
                  <div>
                    Your offer of {formatMoney(offer.offer_amount)} is{' '}
                    <OfferStatusBadge status={offer.status} />
                    {/* <div>{offerStatusTexts[offer.status]}</div> */}
                  </div>
                  <small className="text-muted">
                    {formatDistanceToNow(offer.created_at)}
                  </small>
                </Col>
              </Row>
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </Card>
  );
}

const Loader = () => {
  const loaderLength = [1, 2, 3, 4, 5, 6];
  return (
    <Card className="card-fill">
      <div className="card-header">
        <div className="d-flex justify-content-between">
          <h3 className="card-header-title">Load Offers</h3>
        </div>
      </div>
      <ListGroup className="list-group-flush">
        {loaderLength.map((item) => (
          <ListGroupItem
            key={item}
            style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}
          >
            <Row>
              <Col xs="auto">
                <div className="avatar avatar-sm">
                  <div className="avatar-title font-size-lg rounded-circle bg-light text-white">
                    {/* <Icon type="truck" /> */}
                  </div>
                </div>
              </Col>
              <Col className="ml-n2">
                <h5 className="mb-1">
                  <div
                    className="bg-light rounded"
                    style={{ height: 18, width: 200 }}
                  />
                </h5>

                <div
                  className="bg-light rounded"
                  style={{ height: 16, width: 60 }}
                />
              </Col>
            </Row>
          </ListGroupItem>
        ))}
      </ListGroup>
    </Card>
  );
};
